import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { login } from "./../../reducers/auth/actions";
import StudentDashboard from "../StudentDashboard";
import PrincipalDashboard from "pages/PrincipalDashboard/dashboard/index";
import MasterSchoolDashboard from "pages/MasterDashboard/dashboard/index";
import TeacherDashboardMain from "../TeacherDashboard/dashboard/index";
import TeacherDashboard from "../TeacherDashboard/index";

import {
  getUserProfile,
  saveUserDataToLocalStorage,
  getSelectedBoardAndGradeFromLocal,
} from "../../services/dataServices/userProfileService";
import {
  SuperAdminLogindata,
  TeacherLogindata,
  PrincipalLogindata,
} from "../Login/userData/index";

const mapDispatchToProps = (dispatch) => {
  return {
    login: (payload) => {
      dispatch(login(payload));
    },
  };
};
const mapStateToProps = (state) => {
  // const user = state.auth.user;
  return {
    userType: state.user.user_type,
    userMobile: state.user.user_mobile,
    subjectId: state.user.subjectId,
  };
};

export class DashboardHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userType: "",
      subjectId: "",
    };
  }

  updateFlagHandler = () => {
    this.setState({
      userType: "teacher",
      subjectId: undefined,
    });
  };

  async componentDidMount() {
    // let userType = localStorage.getItem("user_type");
    // let userType = this.props.userType;
    // let subjectId = this.props.subjectId;
    // let Logindata;
    // let modifiedUserRoleObj;
    // if (userType === "teacher") {
    //   Logindata = TeacherLogindata;
    //   modifiedUserRoleObj = { user_type: "teacher" };
    // } else if (userType === "principal") {
    //   Logindata = PrincipalLogindata;
    //   modifiedUserRoleObj = { user_type: "principal" };
    // } else if (userType === "superadmin") {
    //   Logindata = SuperAdminLogindata;
    //   modifiedUserRoleObj = { user_type: "superadmin" };
    // }
    // await saveUserDataToLocalStorage(Logindata);
    // console.log(modifiedUserRoleObj);
    // login({ user: modifiedUserRoleObj });
    let userType = this.props.userType;
    let subjectId = this.props.subjectId;
    this.setState({
      userType: userType,
      subjectId: subjectId,
    });
  }
  render() {
    const { userType, subjectId } = this.state;
    // let userType = localStorage.getItem('user_type')
    if (userType === "teacher" && subjectId !== undefined) {
      return (
        <div>
          <TeacherDashboard changeRouteHandler={this.updateFlagHandler} />
        </div>
      );
    } else if (userType === "teacher" && subjectId == undefined) {
      return (
        <div>
          <TeacherDashboardMain />
        </div>
      );
    } else if (userType === "principal") {
      return (
        <div>
          <PrincipalDashboard />
        </div>
      );
    } else if (userType === "superadmin") {
      return (
        <div>
          <MasterSchoolDashboard />
        </div>
      );
    } else if (userType === "student") {
      return (
        <div>
          <StudentDashboard />
        </div>
      );
    } else {
      return <></>;
    }
  }
}

export default withRouter(connect(mapStateToProps, null)(DashboardHome));
